
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promo",
      function () {
        return require("private-next-pages/promo/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promo"])
      });
    }
  